export enum ResetPasswordFormFields {
  Email = 'email',
  Password = 'password',
  ConfirmPassword = 'confirmPassword',
  Token = 'token',
}
